import React from "react";
import { Icon, Text } from "@bookingcom/bui-react";
import { useI18n } from "@bookingcom/lingojs-react";
import FlightDetailsAncillaryItemLayout from "../../FlightDetailsAncillaryItemLayout/index.js";
import { includedBaggageIcons } from "@flights/branded-fares";
import { SPACER_PADDED } from "@flights/constants";
import { formattingUtils } from "@flights/web-api-utils-universal";
import useRouteName from "../../../../hooks/useRouteName.js";
import { FlightDetailsInfoDesktopUI } from "../../../ui/FlightDetails/FlightDetailsInfo.desktop.ui.js";
export function BaggageItemDesktop(props) {
    const { luggage, alignIconCenter, detailsPerTraveller, extraTestId, footer, hideIncludedSection, subtitle } = props;
    const i18n = useI18n();
    const IconSVG = includedBaggageIcons[luggage.luggageType];
    const { title: defaultTitle, size, weightPerPiece, totalWeight } = formattingUtils.luggageAllowanceCopyV2(luggage, i18n);
    const restrictions = [size, totalWeight, weightPerPiece].filter(Boolean);
    const routeName = useRouteName();
    const isWeightBasedWithContent = (allowance) => {
        return (allowance.luggageType === "CHECKED_IN" &&
            "ruleType" in allowance &&
            allowance.ruleType === "WEIGHT_BASED" &&
            "content" in allowance &&
            !!allowance.content);
    };
    let title = defaultTitle;
    let subtitleToUse = subtitle;
    let extraInfo = null;
    let subtitleFromContent = false;
    if (isWeightBasedWithContent(luggage)) {
        title = luggage.content.titleCondensed || defaultTitle;
        extraInfo =
            routeName === "flightdetails"
                ? null
                : detailsPerTraveller
                    ? luggage.content.soloExtraInfo
                    : luggage.content.extraInfo;
        const contentForSubtitle = detailsPerTraveller ? luggage.content.soloSubtitle : luggage.content.subtitle;
        if (contentForSubtitle) {
            subtitleFromContent = true;
            subtitleToUse =
                typeof contentForSubtitle === "string" ? (React.createElement(Text, { variant: "body_2" }, contentForSubtitle)) : (contentForSubtitle);
        }
    }
    const description = routeName === "flightdetails" && subtitleFromContent
        ? null
        : extraInfo || (restrictions.length > 0 ? restrictions.join(SPACER_PADDED) : null);
    return (React.createElement(FlightDetailsInfoDesktopUI.Item, { svg: IconSVG, inclusionType: "INCLUDED" },
        React.createElement(FlightDetailsAncillaryItemLayout, { renderTextOnly: true, icon: React.createElement(Icon, { svg: IconSVG, size: "large" }), content: React.createElement(React.Fragment, null,
                React.createElement(Text, { attributes: { "data-testid": "baggage_title" }, variant: "body_2" }, title),
                subtitleToUse,
                description && (React.createElement(Text, { attributes: { "data-testid": "baggage_description" }, variant: "body_2" }, description)),
                footer), includedBaggage: true, hideIncludedSection: hideIncludedSection, alignIconCenter: alignIconCenter, extraTestId: extraTestId })));
}
